module.exports = __webpack_public_path__ + "static/media/banner_4.f8adae45.jpg";